import { render, staticRenderFns } from "./TempCopyRight.vue?vue&type=template&id=243dd5b1&scoped=true&"
import script from "./TempCopyRight.vue?vue&type=script&lang=js&"
export * from "./TempCopyRight.vue?vue&type=script&lang=js&"
import style0 from "./TempCopyRight.vue?vue&type=style&index=0&id=243dd5b1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "243dd5b1",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/tachyon/facade-configurator/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('243dd5b1')) {
      api.createRecord('243dd5b1', component.options)
    } else {
      api.reload('243dd5b1', component.options)
    }
    module.hot.accept("./TempCopyRight.vue?vue&type=template&id=243dd5b1&scoped=true&", function () {
      api.rerender('243dd5b1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/UI/TempCopyRight.vue"
export default component.exports